module.exports = __webpack_public_path__ + "media/Winner Selected.82aae342.mp3";